module.exports = __webpack_public_path__ + "static/media/speech-bubble.cf1b809e.svg";